import { Conversation } from 'model';
import styles from './ConversationItem.module.css';
import { ProfilePic } from './ProfilePic.js';
import { Badge } from './Badge.js';
import { useHistory } from 'react-router-dom';

export type ConversationItemProps = {
	item: Conversation;
};

export function ConversationItem({ item }: ConversationItemProps) {
	const history = useHistory();
	return (
		<div
			className={styles.ConversationItem}
			data-testid={`ConversationItem-${item.user._id}`}
			onClick={() => history.push(`/main/messages/${item.user._id}`)}
		>
			<ProfilePic user={item.user} disableClick />

			<div className={styles.usernameMessageContainer}>
				<span className={styles.username}>{item.user.username}</span>
				{item.lastMessage && <div className={styles.lastMessage}>{item.lastMessage?.message ?? ''}</div>}
			</div>
			<Badge content={item.unreadCount || undefined} type="notify" />
		</div>
	);
}
